<template>
  <img v-if="iconMap[icon]" v-tippy="tooltip" :src="iconMap[icon]" :style="{ height: size, width: 'auto' }" />
  <component
    :is="mdiIcons[snakeCaseToPascalCase(icon)]"
    v-else
    v-tippy="tooltip"
    :style="{ height: size, width: size }"
  />
</template>

<script setup lang="ts">
import Accessible from '~icons/material-symbols/accessible';
import AddCircleOutline from '~icons/material-symbols/add-circle-outline';
import ArrowBack from '~icons/material-symbols/arrow-back';
import BlurOn from '~icons/material-symbols/blur-on';
import BubbleChart from '~icons/material-symbols/bubble-chart';
import CenterFocusStrong from '~icons/material-symbols/center-focus-strong';
import CloudUpload from '~icons/material-symbols/cloud-upload';
import CropDin from '~icons/ic/outline-crop-din';
import Dialpad from '~icons/material-symbols/dialpad';
import DirectionsRun from '~icons/material-symbols/directions-run';
import Download from '~icons/material-symbols/download';
import Extension from '~icons/material-symbols/extension';
import Gesture from '~icons/material-symbols/gesture';
import Highlight from '~icons/material-symbols/highlight';
import KeyboardArrowDown from '~icons/material-symbols/keyboard-arrow-down';
import KeyboardArrowLeft from '~icons/material-symbols/keyboard-arrow-left';
import KeyboardArrowRight from '~icons/material-symbols/keyboard-arrow-right';
import KeyboardArrowUp from '~icons/material-symbols/keyboard-arrow-up';
import LabelOutline from '~icons/material-symbols/label-outline';
import LocalBar from '~icons/material-symbols/local-bar';
import LockOutline from '~icons/material-symbols/lock-outline';
import PanoramaFishEye from '~icons/material-symbols/panorama-fish-eye';
import PhotoSizeSelectLarge from '~icons/material-symbols/photo-size-select-large';
import Remove from '~icons/material-symbols/remove';
import RemoveCircleOutline from '~icons/ic/outline-remove-circle-outline';
import Restaurant from '~icons/material-symbols/restaurant';
import Save from '~icons/material-symbols/save';
import Share from '~icons/material-symbols/share';
import ConversionPath from '~icons/material-symbols/conversion-path';
import SignalCellularNull from '~icons/material-symbols/signal-cellular-null';
import Star from '~icons/material-symbols/star';
import StarBorder from '~icons/ic/outline-star-border';
import Store from '~icons/material-symbols/store';
import TextFields from '~icons/material-symbols/text-fields';
import ViewQuilt from '~icons/material-symbols/view-quilt';
import Wallpaper from '~icons/material-symbols/wallpaper';
import Warning from '~icons/material-symbols/warning';
import Wc from '~icons/material-symbols/wc';
import RadioButtonUnchecked from '~icons/material-symbols/radio-button-unchecked';
import CheckBoxOutlineBlank from '~icons/material-symbols/check-box-outline-blank';
import DataUsage from '~icons/material-symbols/data-usage';
import List from '~icons/material-symbols/list';
import Clipboard from '~icons/material-symbols/copy-all-outline';
import EyeOff from '~icons/mdi/eye-off';
import Pin from '~icons/material-symbols/pin-drop-outline';

const icons = import.meta.glob('@/assets/img/*.png', { eager: true });

const mdiIcons = {
  BlurOn,
  ViewQuilt,
  Dialpad,
  BubbleChart,
  PhotoSizeSelectLarge,
  TextFields,
  StarBorder,
  SignalCellularNull,
  Remove,
  PanoramaFishEye,
  CropDin,
  Share,
  ConversionPath,
  Star,
  Restaurant,
  LocalBar,
  DirectionsRun,
  Wc,
  Highlight,
  Accessible,
  Wallpaper,
  AddCircleOutline,
  RemoveCircleOutline,
  KeyboardArrowUp,
  KeyboardArrowRight,
  KeyboardArrowDown,
  KeyboardArrowLeft,
  CenterFocusStrong,
  Gesture,
  Extension,
  ArrowBack,
  Save,
  Download,
  LabelOutline,
  Store,
  LockOutline,
  Warning,
  CloudUpload,
  RadioButtonUnchecked,
  CheckBoxOutlineBlank,
  DataUsage,
  List,
  Clipboard,
  EyeOff,
  Pin,
};

const iconMap = Object.fromEntries(
  Object.entries(icons).map(([key, value]) => {
    const name = key.split('/').pop()?.split('.')[0];
    return [name, (value as { default: string }).default];
  })
);

const props = defineProps({
  icon: {
    type: String,
    required: true,
  },
  size: {
    type: String,
    default: '1.7em',
  },
  tooltip: {
    type: String,
  },
});

const snakeCaseToPascalCase = (str: string) => {
  return str
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join('');
};
</script>
